module.exports = __webpack_public_path__ + "img/1_ru.728650e3.webp";